import { useLocale } from "../../../intl";

export default function CasaMapaAdminAnalyticsSectionShell({
  introKey,
  toolbar = null,
  className = "",
  error = "",
  loading = false,
  loadingLabel,
  children,
}) {
  const { t } = useLocale();

  return (
    <section className={`panel-card cm-admin-analytics__section${className ? ` ${className}` : ""}`}>
      <header className="cm-admin-analytics__section-head">
        <p className="cm-admin-analytics__section-intro muted">{t(introKey)}</p>
        {toolbar}
      </header>

      {error ? <p className="form-error">{error}</p> : null}
      {loading ? <p className="muted">{loadingLabel || t("realEstate.casaMapa.admin.loading")}</p> : null}

      {!loading ? children : null}
    </section>
  );
}
